<template>
  <div class="member-avatar" :class="sizeClass">
    <CachedImage v-if="photoUrl" :src="photoUrl" :alt="name">
      <template #fallback>
        <span class="initials">{{ initials }}</span>
      </template>
    </CachedImage>
    <span v-else class="initials">{{ initials }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import CachedImage from '@shared/components/CachedImage.vue'

const props = defineProps({
  photoUrl: String,
  name: { type: String, required: true },
  size: { type: String, default: 'md' } // sm, md, lg
})

const initials = computed(() => {
  if (!props.name) return '?'
  return props.name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
})

const sizeClass = computed(() => `avatar-${props.size}`)
</script>

<style scoped>
@import '@shared/styles/intercom-tokens.css';

.member-avatar {
  border-radius: 50%;
  background: var(--color-gray-200);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.member-avatar :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.initials {
  color: var(--color-gray-600);
  font-weight: var(--font-weight-semibold);
}

.avatar-sm {
  width: 32px;
  height: 32px;
  font-size: var(--font-size-xs);
}

.avatar-md {
  width: 48px;
  height: 48px;
  font-size: var(--font-size-sm);
}

.avatar-lg {
  width: 80px;
  height: 80px;
  font-size: var(--font-size-xl);
}
</style>
